import { toast } from "react-toastify";

export class AlertsModel {
  static dingSound = new Audio("https://swivl-cdn.s3-us-west-1.amazonaws.com/notification_sound.mp3");

  static toastsById: any = {};
  static clearEscalationNotification(escalationId) {
    if (AlertsModel.toastsById[escalationId]) {
      // const unresolvedEscalations = EscalationsModel.unresolvedEscalations();
      //
      // if (unresolvedEscalations.length > 1) {
      //   // AlertsModel.clearNotification();
      // }
      toast.dismiss(AlertsModel.toastsById[escalationId]);
      delete AlertsModel.toastsById[escalationId];
    }
  }

  // //  static hasNotificationTime?:number
  // //  static hasNotification:boolean;
  // //  static numberOfHootsPlayed:number = 0;

  //  static soundInterval = setInterval( () => {
  //   if (ConversationsModel.hasUnresolvedEscalations() && AgentModel.state.isAvailable ) {
  //     // AlertsModel.hasNotificationTime = Date.now();
  //     // AlertsModel.numberOfHootsPlayed = AlertsModel.numberOfHootsPlayed + 1;

  //     AlertsModel.dingSound.play().catch((e) => {

  //     })
  //   }

  // }, 6000);

  //   // static testInterval = setTimeout(() => {

  //   //   AlertsModel.displayNotification("Test Notification",null, null, true, true)
  //   // }, 7000)

  //   static dingSound = new Audio('https://swivl-cdn.s3-us-west-1.amazonaws.com/notification_sound.mp3');

  //   static notificationState() {
  //     const userSettings =  (UserModel.state.user && UserModel.state.user.get("settings")) ? UserModel.state.user.get("settings") : {}
  //     if (!userSettings) { return null }
  //     if (userSettings.isNotificationOn) {  if (userSettings.notificationType === "alert") { return "alert"; } else { return "push"; }
  //     } else {  if (userSettings.notificationType === "alert") { return "off_alert"; } else { return "off_push"; }  }
  //   }

  //   static displayNotification(message, onClick?, onClose?, updateIcon?, playSound?, autoClose?, className?, bodyClassName?, notificationId?:string) {
  //     log("displayNotification ");
  //     // if (updateIcon) {
  //     //   AlertsModel.hasNotificationTime = Date.now();
  //     //   AlertsModel.hasNotification = true;
  //     //   AlertsModel.numberOfHootsPlayed = 0;

  //     // }
  //     if (playSound) {
  //       AlertsModel.dingSound.play();
  //     }
  //     let options:any = {
  //       position: toast.POSITION.BOTTOM_RIGHT,
  //       progressClassName: "notification-progress-bar"
  //     };
  //     if (onClick) { options.onClick = () => {
  //       // AlertsModel.clearNotification();
  //       onClick();
  //       }
  //     }
  //     if (onClose) {
  //       options.onClose = () => {
  //       // AlertsModel.clearNotification()
  //       onClose();
  //     }; } else {
  //       options.onClose = () => {
  //         // AlertsModel.clearNotification() ;
  //       }
  //     }
  //     if (autoClose && autoClose > 0) {
  //       options.autoClose = autoClose;
  //     } else {
  //       options.autoClose = false;
  //     }
  //     if (className) { options.className = className; } else { options.className= "generic-notification"}
  //     if (bodyClassName) { options.bodyClassName = bodyClassName; } else { options.bodyClassName = 'generic-notification-body'}

  //     if (notificationId) {
  //       AlertsModel.toastsById[notificationId] = toast(message, options);
  //     } else {
  //       toast(message, options);
  //     }

  //   }

  //   // static clearNotification() {
  //   //
  //   //   AlertsModel.hasNotification = false;
  //   // }

  static successToast(message: string) {
    toast.success(message, {
      position: "bottom-right",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined
    });
  }

  static errorToast(errorMsg: string) {
    toast.error(errorMsg, {
      position: "bottom-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined
    });
  }

  // static receivedNotification(notification) {
  //   log("receivedNotification",notification)

  //   if (AgentModel.state.isAvailable) {
  //     const onClick = () => { NavigationHelper.navigate("/contact-center/conversations/" + notification.botUserId); };
  //     //     displayNotification(message,             onClick, onClose, updateIcon, playSound, autoClose, className, bodyClassName) {
  //     // AlertsModel.displayNotification("Testing",          onClick, null,     true,      true,     null,       "chat-notification", "chat-notification-body")

  //     AlertsModel.displayNotification(notification.message,onClick,  null,  true,      true,      false,    "chat-notification", "chat-notification-body")
  //   } else {
  //     log("Not going to show notification")
  //   }
  // }

  // static receivedEscalationNotification(escalation) {
  //   if (!AgentModel.state.isAvailable) {
  //     log("Not going to show notification receivedEscalationNotification")

  //     return;
  //   }
  //   AlertsModel.dingSound.play().catch((e) => { })

  //   const location =  window.location;
  //   if (location.pathname.includes("conversations")) {
  //     log("On conversation page, not going to show notification")
  //     return;
  //   }

  //     const onClick = () => { NavigationHelper.navigate("/contact-center/conversations/" + escalation.user.id); };

  //     log("Should display notification");

  //     AlertsModel.displayNotification("Someone needs assistance",onClick,  null,  true,      true,      false,    "chat-notification", "chat-notification-body", escalation.id)

  // }
}
